import cloudFunctionGetService from './cloudFunction.get.service';

export default async function getDbProfilesService() {
  return await cloudFunctionGetService('getDbProfiles')
}